import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Select from 'react-select';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import TextareaCounter from '../../FormComponents/TextareaCounter';
import LocationDropDown from '../../Dashboard/Stats/LocationDropDown';

export default class HiddenPreferences extends Component {
  constructor(props) {
    super(props);

    this.state = {
      locationOptions: [],
      blockedWordsInput: '',
      fieldErrors: {},
      staffOptions: [],
      serviceOptions: [],
      resourceOptions: [],
    };

    this.availabilityOptions = [
      { label: 'Slot Based', value: 'SLOT_BASED' },
      { label: 'Schedule Based', value: 'SCHEDULE_BASED' },
      { label: 'Schedule and Slot Based', value: 'SCHEDULE_AND_SLOT_BASED' },
    ];

    // this.workflowOptions = [
    //   { label: 'Pre Booking', value: 'PRE_BOOKING' },
    //   { label: 'Pre Enrollment', value: 'PRE_ENROLLMENT' },
    // ];

    // this.notificationOptions = [
    //   { label: 'Instantly', value: 'INSTANTLY' },
    //   { label: 'Daily', value: 'DAILY' },
    //   { label: 'Hourly', value: 'HOURLY' },
    // ];

    this.businessBrandOptions = [
      { label: 'Brand', value: 'BRAND' },
      { label: 'Business', value: 'BUSINESS' },
      { label: 'Business Brand', value: 'BUSINESS_BRAND' },
      { label: 'None', value: 'NONE' },
    ];

    this.slotSizeOptions = [
      { label: '5 minutes', value: 'PT5M' },
      { label: '10 minutes', value: 'PT10M' },
      { label: '15 minutes', value: 'PT15M' },
      { label: '30 minutes', value: 'PT30M' },
      { label: '1 hour', value: 'PT1H' },
    ];

    this.durationOptions = [
      { label: '5 minutes', value: 'PT5M' },
      { label: '10 minutes', value: 'PT10M' },
      { label: '15 minutes', value: 'PT15M' },
      { label: '30 minutes', value: 'PT30M' },
      { label: '1 hour', value: 'PT1H' },
      { label: '2 hours', value: 'PT2H' },
      { label: '4 hours', value: 'PT4H' },
      { label: '8 hours', value: 'PT8H' },
      { label: '12 hours', value: 'PT12H' },
      { label: '1 day', value: 'PT24H' },
      { label: '3 days', value: 'PT72H' },
      { label: '1 week', value: 'PT168H' },
    ];

    this.customStyles = {
      menu: (provided, state) => ({
        ...provided,
        zIndex: 3,
      }),
      control: (provided) => ({
        ...provided,
        minHeight: '50px',
        borderColor: '#cfd0d1',
      }),
      multiValue: (provided) => ({
        ...provided,
        backgroundColor: '#e6e6e6',
        borderRadius: '4px',
      }),
      multiValueLabel: (provided) => ({
        ...provided,
        color: '#333',
        fontSize: '14px',
      }),
      multiValueRemove: (provided) => ({
        ...provided,
        color: '#666',
        ':hover': {
          backgroundColor: '#d0d0d0',
          color: '#333',
        },
      }),
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected
          ? '#e6e6e6'
          : state.isFocused
            ? '#efefef'
            : 'white',
        color: '#333',
        ':hover': {
          backgroundColor: '#efefef',
          color: '#333',
        },
        ':active': {
          backgroundColor: '#e6e6e6',
        },
      }),
    };

    this.setFieldError = this.setFieldError.bind(this);
    this.getFieldError = this.getFieldError.bind(this);
    this.generateLocationOptions = this.generateLocationOptions.bind(this);
    this.getSelectedLocationOption = this.getSelectedLocationOption.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.getPreferencesData = this.getPreferencesData.bind(this);
    this.generateStaffOptions = this.generateStaffOptions.bind(this);
    this.generateServiceOptions = this.generateServiceOptions.bind(this);
    this.generateResourceOptions = this.generateResourceOptions.bind(this);
    this.onBlockedStaffChange = this.onBlockedStaffChange.bind(this);
    this.onBlockedServiceChange = this.onBlockedServiceChange.bind(this);
    this.onBlockedLocationChange = this.onBlockedLocationChange.bind(this);
    this.onBlockedResourceChange = this.onBlockedResourceChange.bind(this);
    this.onAvailabilityTypeChange = this.onAvailabilityTypeChange.bind(this);
    this.onCancellationTypeChange = this.onCancellationTypeChange.bind(this);
    this.onWorkflowTypeChange = this.onWorkflowTypeChange.bind(this);
    this.onNotificationFrequencyChange = this.onNotificationFrequencyChange.bind(this);
    this.onRecipientTypeChange = this.onRecipientTypeChange.bind(this);
    this.onBusinessBrandChange = this.onBusinessBrandChange.bind(this);
    this.onPreferredLocationChange = this.onPreferredLocationChange.bind(this);
    this.onAutoCancel = this.onAutoCancel.bind(this);
    this.onPromotionalAddClient = this.onPromotionalAddClient.bind(this);
    this.onSendLeStatusBn = this.onSendLeStatusBn.bind(this);
    this.onSendStaffInfo = this.onSendStaffInfo.bind(this);
    this.onAcceptVoucherBookings = this.onAcceptVoucherBookings.bind(this);
    this.onRescheduleAnyStaff = this.onRescheduleAnyStaff.bind(this);
    this.onLinkedAppointmentWithSameStaff = this.onLinkedAppointmentWithSameStaff.bind(this);
    this.onAlwaysNotify = this.onAlwaysNotify.bind(this);
    this.onCustomPostBookingInstructionsChange = this.onCustomPostBookingInstructionsChange.bind(this);
    this.onRequestForwardedMessageChange = this.onRequestForwardedMessageChange.bind(this);
    this.onNotesChange = this.onNotesChange.bind(this);
    this.onSlotSizeChange = this.onSlotSizeChange.bind(this);
    this.onSlotIntervalChange = this.onSlotIntervalChange.bind(this);
    this.onSlotIntervalToggle = this.onSlotIntervalToggle.bind(this);
    this.onUserLoginLinkChange = this.onUserLoginLinkChange.bind(this);
    this.onIsMultiLocation = this.onIsMultiLocation.bind(this);
    this.onIsOnboardedAsMulti = this.onIsOnboardedAsMulti.bind(this);
    this.onStaffPreferenceHonoured = this.onStaffPreferenceHonoured.bind(this);
    this.onExtraSecureAppointmentStrings = this.onExtraSecureAppointmentStrings.bind(this);
    this.onSendStaffFirstName = this.onSendStaffFirstName.bind(this);
    this.onBlockBookingSwCalls = this.onBlockBookingSwCalls.bind(this);
    this.onBlockAutoProposal = this.onBlockAutoProposal.bind(this);
    this.onEnableSpeechHint = this.onEnableSpeechHint.bind(this);
    this.onEmailAddClient = this.onEmailAddClient.bind(this);
    this.onSmsAddClient = this.onSmsAddClient.bind(this);
    this.onLeadEngageFollowUpTimeChange = this.onLeadEngageFollowUpTimeChange.bind(this);
    this.onCancelAndBook = this.onCancelAndBook.bind(this);
    this.onStaging = this.onStaging.bind(this);
    this.onCollectCcBeforeBooking = this.onCollectCcBeforeBooking.bind(this);
    this.onCcWaitTimeToBookingChange = this.onCcWaitTimeToBookingChange.bind(this);
    this.onShowZeroDurationAppointmentSegments = this.onShowZeroDurationAppointmentSegments.bind(this);
    this.onHideServiceTimes = this.onHideServiceTimes.bind(this);
    this.onStaffScheduleSpanChange = this.onStaffScheduleSpanChange.bind(this);
    this.onAllowUnpaidBookings = this.onAllowUnpaidBookings.bind(this);
    this.onBlockedWordsInputChange = this.onBlockedWordsInputChange.bind(this);
    this.addBlockedWord = this.addBlockedWord.bind(this);
    this.removeBlockedWord = this.removeBlockedWord.bind(this);
    this.onStaffLocationPreferencesChange = this.onStaffLocationPreferencesChange.bind(this);
    this.onLocationWorkflowPreferencesChange = this.onLocationWorkflowPreferencesChange.bind(this);
    this.onCustomGreetingFNameChange = this.onCustomGreetingFNameChange.bind(this);
    this.onRecipientNameChange = this.onRecipientNameChange.bind(this);
    this.onHoursToCancelChange = this.onHoursToCancelChange.bind(this);
    this.onCancellationDetailChange = this.onCancellationDetailChange.bind(this);
    this.onClientNotificationChange = this.onClientNotificationChange.bind(this);
    this.removeResourceStartTime = this.removeResourceStartTime.bind(this);
    this.onResourceStartTimeChange = this.onResourceStartTimeChange.bind(this);
    this.onSubscribedEventChange = this.onSubscribedEventChange.bind(this);
  }

  getPreferencesData() {
    if (this.props.details && Object.keys(this.props.details).length > 0) {
      return this.props.details;
    }
    const apiData = this.props.apiData || this.props.preferences || {};
    if (apiData.preferences) {
      return apiData.preferences;
    }
    return {};
  }

  static validateStringField(value, fieldName, maxLength = null, required = false) {
    let processedValue = value;
    if (processedValue === null || processedValue === undefined) {
      processedValue = '';
    }

    if (typeof processedValue !== 'string') {
      return { message: `${fieldName} must be a string` };
    }

    if (required && processedValue.trim() === '') {
      return { message: `${fieldName} is required` };
    }

    if (maxLength && processedValue.length > maxLength) {
      return { message: `${fieldName} is too long (maximum ${maxLength} characters)` };
    }

    if (processedValue.trim() !== '') {
      const trimmedValue = processedValue.trim();

      if (/^\d+$/.test(trimmedValue)) {
        return { message: `${fieldName} cannot contain only numbers` };
      }

      if (/^[^a-zA-Z0-9]+$/.test(trimmedValue)) {
        return { message: `${fieldName} cannot contain only special characters` };
      }

      if (!/[a-zA-Z]/.test(trimmedValue)) {
        return { message: `${fieldName} must contain at least one letter` };
      }
    }

    return null;
  }

  static validateUrlField(value, fieldName, required = false) {
    let processedValue = value;
    if (processedValue === null || processedValue === undefined) {
      processedValue = '';
    }

    if (typeof processedValue !== 'string') {
      return { message: `${fieldName} must be a string` };
    }

    if (required && processedValue.trim() === '') {
      return { message: `${fieldName} is required` };
    }

    if (processedValue.length > 2048) {
      return { message: `${fieldName} is too long (maximum 2048 characters)` };
    }

    if (!processedValue || processedValue.trim() === '') {
      return null;
    }

    const trimmedValue = processedValue.trim();
    if (trimmedValue.includes(' ')) {
      return { message: `Please enter a valid ${fieldName.toLowerCase()} (URLs cannot contain spaces)` };
    }
    let domainToCheck = trimmedValue;
    if (domainToCheck.startsWith('http://')) {
      domainToCheck = domainToCheck.substring(7);
    } else if (domainToCheck.startsWith('https://')) {
      domainToCheck = domainToCheck.substring(8);
    }

    domainToCheck = domainToCheck.split('/')[0].split('?')[0].split('#')[0];

    if (!domainToCheck.startsWith('www.')) {
      return { message: `Please enter a valid ${fieldName.toLowerCase()} (must start with www., e.g., www.example.com)` };
    }
    if (domainToCheck.endsWith('.') || domainToCheck.includes('..') || domainToCheck === 'www.') {
      return { message: `Please enter a valid ${fieldName.toLowerCase()} (invalid domain format)` };
    }
    const domainParts = domainToCheck.split('.');

    if (domainParts.length < 3) {
      return { message: `Please enter a valid ${fieldName.toLowerCase()} (must include domain and extension, e.g., www.example.com)` };
    }

    for (let i = 0; i < domainParts.length; i += 1) {
      const part = domainParts[i];
      if (!part || part.length === 0) {
        return { message: `Please enter a valid ${fieldName.toLowerCase()} (invalid domain format)` };
      }
      if (!/^[a-zA-Z0-9-]+$/.test(part)) {
        return { message: `Please enter a valid ${fieldName.toLowerCase()} (domain contains invalid characters)` };
      }
      if (part.startsWith('-') || part.endsWith('-')) {
        return { message: `Please enter a valid ${fieldName.toLowerCase()} (domain parts cannot start or end with hyphens)` };
      }
    }
    const tld = domainParts[domainParts.length - 1];
    if (tld.length < 2) {
      return { message: `Please enter a valid ${fieldName.toLowerCase()} (domain extension must be at least 2 characters, e.g., .com, .co)` };
    }

    if (!/^[a-zA-Z]+$/.test(tld)) {
      return { message: `Please enter a valid ${fieldName.toLowerCase()} (domain extension must contain only letters)` };
    }

    let urlToValidate = trimmedValue;
    if (!trimmedValue.startsWith('http://') && !trimmedValue.startsWith('https://')) {
      urlToValidate = `https://${trimmedValue}`;
    }

    try {
      // eslint-disable-next-line no-new
      new URL(urlToValidate);
    } catch {
      return { message: `Please enter a valid ${fieldName.toLowerCase()} (invalid URL format)` };
    }

    return null;
  }

  static validateNumberField(value, fieldName, min = null, max = null, required = false) {
    let processedValue = value;
    if (processedValue === null || processedValue === undefined) {
      processedValue = '';
    }

    const stringValue = String(processedValue);

    if (required && stringValue.trim() === '') {
      return { message: `${fieldName} is required` };
    }

    if (!stringValue || stringValue.trim() === '') {
      return null;
    }

    const numValue = Number(stringValue);
    if (Number.isNaN(numValue)) {
      return { message: `${fieldName} must be a valid number` };
    }

    if (min !== null && numValue < min) {
      return { message: `${fieldName} must be at least ${min}` };
    }

    if (max !== null && numValue > max) {
      return { message: `${fieldName} must be no more than ${max}` };
    }

    return null;
  }

  static validateFileNameField(value, fieldName, required = false) {
    let processedValue = value;
    if (processedValue === null || processedValue === undefined) {
      processedValue = '';
    }

    if (typeof processedValue !== 'string') {
      return { message: `${fieldName} must be a string` };
    }

    if (required && processedValue.trim() === '') {
      return { message: `${fieldName} is required` };
    }

    if (processedValue.length > 255) {
      return { message: `${fieldName} is too long (maximum 255 characters)` };
    }

    if (!processedValue || processedValue.trim() === '') {
      return null;
    }

    const trimmedValue = processedValue.trim();

    const invalidChars = /[<>:"/\\|?*]/;
    if (invalidChars.test(trimmedValue)) {
      return { message: `${fieldName} contains invalid characters (< > : " / \\ | ? *)` };
    }

    const hasExtension = /\.[a-zA-Z0-9]+$/.test(trimmedValue);
    if (!hasExtension) {
      return { message: `${fieldName} should include a file extension (e.g., .mp3, .wav)` };
    }

    return null;
  }

  static validateJSONField(value, fieldName, required = false) {
    let processedValue = value;
    if (processedValue === null || processedValue === undefined) {
      processedValue = '';
    }

    if (typeof processedValue !== 'string') {
      return { message: 'There must be a string' };
    }

    if (!processedValue || processedValue.trim() === '') {
      return null;
    }

    const trimmedValue = processedValue.trim();
    if (!trimmedValue.startsWith('{') || !trimmedValue.endsWith('}')) {
      return { message: 'The value must be a valid JSON object (e.g., {"key": "value"})' };
    }

    try {
      const parsed = JSON.parse(trimmedValue);
      if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
        return { message: 'The value must be a valid JSON object' };
      }
      return null;
    } catch (error) {
      return { message: 'The value contains invalid JSON syntax' };
    }
  }

  static validateNameField(value, fieldName, required = false) {
    let processedValue = value;
    if (processedValue === null || processedValue === undefined) {
      processedValue = '';
    }

    if (typeof processedValue !== 'string') {
      return { message: `${fieldName} must be a string` };
    }

    if (required && processedValue.trim() === '') {
      return { message: `${fieldName} is required` };
    }

    if (processedValue.length > 100) {
      return { message: `${fieldName} is too long (maximum 100 characters)` };
    }

    if (!processedValue || processedValue.trim() === '') {
      return null;
    }

    const trimmedValue = processedValue.trim();

    if (!/^[a-zA-Z\s]+$/.test(trimmedValue)) {
      return { message: `${fieldName} should only contain letters and spaces` };
    }

    if (!/[a-zA-Z]/.test(trimmedValue)) {
      return { message: `${fieldName} must contain at least one letter` };
    }

    return null;
  }

  setFieldError(fieldName, error) {
    if (this.props.onErrorChange) {
      this.props.onErrorChange(fieldName, error);
    } else {
      this.setState((prevState) => ({
        fieldErrors: {
          ...prevState.fieldErrors,
          [fieldName]: error,
        },
      }));
    }
  }

  getFieldError(fieldName) {
    return (this.props.errors && this.props.errors[fieldName])
           || (this.state.fieldErrors && this.state.fieldErrors[fieldName]);
  }

  generateLocationOptions() {
    const business = this.props.business || {};
    const businessDetails = business.details || business.data || {};

    const businessId = business.id || business.info?.ID || business.clientUser?.id || businessDetails.id;

    if (!businessId) {
      this.setState({ locationOptions: [{ label: 'Loading locations...', value: '', disabled: true }] });
      return;
    }

    let locations = [];

    if (businessDetails.locations && Array.isArray(businessDetails.locations) && businessDetails.locations.length > 0) {
      locations = businessDetails.locations;
    } else if (business.locations && Array.isArray(business.locations) && business.locations.length > 0) {
      locations = business.locations;
    }

    if (locations.length === 0) {
      this.setState({ locationOptions: [{ label: 'No locations available', value: '', disabled: true }] });
      return;
    }

    const activeLocations = locations.filter((location) => !location.disabled);

    const newLocationOptions = [
      // { label: 'Select Location', value: '' },
      ...activeLocations.map((location) => {
        let locationId;
        let locationName;

        if (location.id && location.name) {
          locationId = location.id;
          locationName = location.name || location.display_text;
        } else if (location.studioId) {
          locationId = location.studioId;
          locationName = location.studioName || location.locationName || location.businessName;
        } else {
          locationId = location.id || location.studioId;
          locationName = location.name || location.studioName || location.locationName;
        }

        return {
          label: locationName,
          value: String(locationId),
          locationData: location,
          studioId: location.studioId || locationId,
        };
      }),
    ];

    this.setState({ locationOptions: newLocationOptions });
  }

  generateStaffOptions() {
    const business = this.props.business || {};
    const businessDetails = business.details || business.data || {};

    let staffs = [];

    if (businessDetails.staffs && Array.isArray(businessDetails.staffs)) {
      staffs = businessDetails.staffs;
    } else if (business.staffs && Array.isArray(business.staffs)) {
      staffs = business.staffs;
    }

    if (staffs.length === 0) {
      this.setState({ staffOptions: [] });
      return;
    }

    const staffOptions = staffs.map((staff) => ({
      label: staff.name || `${staff.first_name || ''} ${staff.last_name || ''}`.trim() || staff.id,
      value: staff.id,
      staff,
    }));

    this.setState({ staffOptions });
  }

  generateServiceOptions() {
    const business = this.props.business || {};
    const businessDetails = business.details || business.data || {};

    let services = [];

    if (businessDetails.services && Array.isArray(businessDetails.services)) {
      services = businessDetails.services;
    } else if (business.services && Array.isArray(business.services)) {
      services = business.services;
    }

    if (services.length === 0) {
      this.setState({ serviceOptions: [] });
      return;
    }

    const serviceOptions = services.map((service) => ({
      label: service.name || service.display_name || service.id,
      value: service.id,
      service,
    }));

    this.setState({ serviceOptions });
  }

  generateResourceOptions() {
    const business = this.props.business || {};
    const businessDetails = business.details || business.data || {};

    let resources = [];

    if (businessDetails.resources && Array.isArray(businessDetails.resources)) {
      resources = businessDetails.resources;
    } else if (business.resources && Array.isArray(business.resources)) {
      resources = business.resources;
    }

    if (resources.length === 0) {
      this.setState({ resourceOptions: [] });
      return;
    }

    const resourceOptions = resources.map((resource) => ({
      label: resource.name || resource.display_name || resource.id,
      value: resource.id,
      resource,
    }));

    this.setState({ resourceOptions });
  }

  static getSelectedBlockedOptions(optionsArray, selectedIds) {
    if (!selectedIds || !Array.isArray(selectedIds) || selectedIds.length === 0) {
      return [];
    }

    return optionsArray.filter((option) => selectedIds.includes(option.value));
  }

  getSelectedLocationOption() {
    const details = this.getPreferencesData();
    const preferredLocationId = details.preferred_location;

    if (!preferredLocationId || !this.state.locationOptions) {
      return null;
    }
    const found = this.state.locationOptions.find((option) => {
      const match = String(option.value) === String(preferredLocationId)
                   || String(option.studioId) === String(preferredLocationId);
      return match;
    });

    return found || null;
  }

  handleChange(fieldName, value, isNested, nestedParent) {
    let eventData;

    if (isNested && nestedParent) {
      const details = this.getPreferencesData();
      const currentParentData = details[nestedParent] || {};
      eventData = {
        target: {
          name: nestedParent,
          value: {
            ...currentParentData,
            [fieldName]: value,
          },
        },
      };
    } else {
      eventData = {
        target: {
          name: fieldName,
          value,
        },
      };
    }
    this.props.onChange(eventData);
  }

  static generateTimeOptions() {
    const times = [];
    for (let hour = 8; hour <= 20; hour += 1) {
      for (let minute = 0; minute < 60; minute += 30) {
        const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}:00`;
        const displayTime = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        times.push({ value: timeString, label: displayTime });
      }
    }
    return times;
  }

  onCancellationDetailChange(field, value) {
    this.handleChange(field, value, true, 'cancellation_details');
  }

  onClientNotificationChange(field, value) {
    this.handleChange(field, value, true, 'client_notification_preferences');
  }

  componentDidMount() {
    this.generateLocationOptions();
    this.generateStaffOptions();
    this.generateServiceOptions();
    this.generateResourceOptions();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.business !== this.props.business) {
      this.generateLocationOptions();
      this.generateStaffOptions();
      this.generateServiceOptions();
      this.generateResourceOptions();
    }
  }

  onBlockedStaffChange(selectedOptions) {
    const selectedIds = selectedOptions ? selectedOptions.map((option) => option.value) : [];
    this.handleChange('blocked_staff', selectedIds);
  }

  onBlockedServiceChange(selectedOptions) {
    const selectedIds = selectedOptions ? selectedOptions.map((option) => option.value) : [];
    this.handleChange('blocked_service', selectedIds);
  }

  onBlockedLocationChange(selectedOptions) {
    const selectedIds = selectedOptions ? selectedOptions.map((option) => option.value) : [];
    this.handleChange('blocked_location', selectedIds);
  }

  onBlockedResourceChange(selectedOptions) {
    const selectedIds = selectedOptions ? selectedOptions.map((option) => option.value) : [];
    this.handleChange('blocked_resources', selectedIds);
  }

  onRequestForwardedMessageChange(e) {
    const value = e.target.value;
    const validationError = HiddenPreferences.validateStringField(value, 'Request forwarded message', 500, false);
    this.setFieldError('request_forwarded_message', validationError);
    this.handleChange('request_forwarded_message', value);
  }

  onNotesChange(e) {
    const value = e.target.value;
    const validationError = HiddenPreferences.validateStringField(value, 'Notes', 500, false);
    this.setFieldError('notes', validationError);
    this.handleChange('notes', value);
  }

  onUserLoginLinkChange(e) {
    const value = e.target.value;
    const validationError = HiddenPreferences.validateUrlField(value, 'User login link', false);
    this.setFieldError('user_login_link', validationError);
    this.handleChange('user_login_link', value);
  }

  onCustomGreetingFNameChange(e) {
    const value = e.target.value;
    const validationError = HiddenPreferences.validateFileNameField(value, 'Custom greeting file name', false);
    this.setFieldError('customGreetingFName', validationError);
    this.handleChange('customGreetingFName', value);
  }

  onRecipientNameChange(e) {
    const value = e.target.value;
    const validationError = HiddenPreferences.validateNameField(value, 'Recipient name', false);
    this.setFieldError('recipient_name', validationError);
    this.onClientNotificationChange('recipient_name', value);
  }

  onHoursToCancelChange(e) {
    const value = e.target.value;
    const validationError = HiddenPreferences.validateNumberField(value, 'Hours to cancel', 0, 168, false);
    this.setFieldError('hours_to_cancel', validationError);
    this.onCancellationDetailChange('HOURS_TO_CANCEL', value);
  }

  onStaffLocationPreferencesChange(e) {
    const value = e.target.value;
    const validationError = HiddenPreferences.validateJSONField(value, 'Staff location preferences', false);
    this.setFieldError('staff_location_preferences', validationError);
    this.handleChange('staff_location_preferences', value);
  }

  onLocationWorkflowPreferencesChange(e) {
    const value = e.target.value;
    const validationError = HiddenPreferences.validateJSONField(value, 'Workflow preference for location', true);
    this.setFieldError('location_workflow_preferences', validationError);
    this.handleChange('location_workflow_preferences', value);
  }

  onCustomPostBookingInstructionsChange(e) {
    const value = e.target.value;
    const validationError = HiddenPreferences.validateJSONField(value, 'Are there any specific post-booking messages you would like TL to share?', true);
    this.setFieldError('custom_post_booking_instructions', validationError);
    this.handleChange('custom_post_booking_instructions', value);
  }

  onAvailabilityTypeChange(item) {
    const value = item ? item.value : '';
    this.handleChange('availability_type', value, true, 'appointment_preferences');
  }

  onCancellationTypeChange(item) {
    const value = item ? item.value : '';
    this.handleChange('CANCELLATION_TYPE', value, true, 'cancellation_details');
  }

  onWorkflowTypeChange(item) {
    const value = item ? item.value : '';
    this.handleChange('pre_workflow_type', value);
  }

  onNotificationFrequencyChange(item) {
    const value = item ? item.value : '';
    this.handleChange('notification_frequency', value, true, 'client_notification_preferences');
  }

  onRecipientTypeChange(item) {
    const value = item ? item.value : '';
    this.handleChange('recipient_type', value, true, 'client_notification_preferences');
  }

  onBusinessBrandChange(item) {
    const value = item ? item.value : '';
    this.handleChange('notifyBusinessBrand', value, true, 'client_notification_preferences');
  }

  onPreferredLocationChange(item) {
    const value = item ? item.value : '';
    this.handleChange('preferred_location', value);

    if (this.props.setDropDownLocation && item && item.locationData) {
      this.props.setDropDownLocation(item.locationData);
    }
  }

  onSlotSizeChange(item) {
    const value = item ? item.value : '';
    this.handleChange('slot_size', value);
  }

  onLeadEngageFollowUpTimeChange(item) {
    const value = item ? item.value : '';
    this.handleChange('lead_engage_follow_up_time', value);
  }

  onCcWaitTimeToBookingChange(item) {
    const value = item ? item.value : '';
    this.handleChange('cc_wait_time_to_booking', value);
  }

  onStaffScheduleSpanChange(item) {
    const value = item ? item.value : '';
    this.handleChange('staff_schedule_span', value);
  }

  onSlotIntervalChange(e) {
    const minutes = parseInt(e.target.value, 10);
    const durationValue = `PT${minutes}M`;
    this.handleChange('slot_interval', durationValue);
  }

  onSlotIntervalToggle() {
    const details = this.getPreferencesData();
    const currentValue = details.slot_interval;
    if (currentValue === null || currentValue === false) {
      this.handleChange('slot_interval', 'PT15M');
    } else {
      this.handleChange('slot_interval', null);
    }
  }

  onAutoCancel() {
    const details = this.getPreferencesData();
    const newValue = !details.can_auto_cancel_if_user_inactive;
    this.props.onChange({
      target: {
        type: 'checkbox',
        name: 'can_auto_cancel_if_user_inactive',
        checked: newValue,
        value: newValue,
      },
    });
  }

  onPromotionalAddClient() {
    const details = this.getPreferencesData();
    const newValue = !details.promotional_add_client;
    this.props.onChange({
      target: {
        type: 'checkbox',
        name: 'promotional_add_client',
        checked: newValue,
        value: newValue,
      },
    });
  }

  onSendLeStatusBn() {
    const details = this.getPreferencesData();
    const newValue = !details.send_le_status_bn;
    this.props.onChange({
      target: {
        type: 'checkbox',
        name: 'send_le_status_bn',
        checked: newValue,
        value: newValue,
      },
    });
  }

  onSendStaffInfo() {
    const details = this.getPreferencesData();
    const newValue = !details.send_staff_info;
    this.props.onChange({
      target: {
        type: 'checkbox',
        name: 'send_staff_info',
        checked: newValue,
        value: newValue,
      },
    });
  }

  onAcceptVoucherBookings() {
    const details = this.getPreferencesData();
    const currentValue = details.appointment_preferences?.accept_voucher_bookings;
    const newValue = !currentValue;
    this.handleChange('accept_voucher_bookings', newValue, true, 'appointment_preferences');
  }

  onRescheduleAnyStaff() {
    const details = this.getPreferencesData();
    const currentValue = details.appointment_preferences?.reschedule_any_staff;
    const newValue = !currentValue;
    this.handleChange('reschedule_any_staff', newValue, true, 'appointment_preferences');
  }

  onLinkedAppointmentWithSameStaff() {
    const details = this.getPreferencesData();
    const currentValue = details.appointment_preferences?.linked_appointment_with_same_staff;
    const newValue = !currentValue;
    this.handleChange('linked_appointment_with_same_staff', newValue, true, 'appointment_preferences');
  }

  onAlwaysNotify() {
    const details = this.getPreferencesData();
    const currentValue = details.client_notification_preferences?.always_notify;
    const newValue = !currentValue;
    this.handleChange('always_notify', newValue, true, 'client_notification_preferences');
  }

  onIsMultiLocation() {
    const details = this.getPreferencesData();
    const newValue = !details.is_multi_location;
    this.handleChange('is_multi_location', newValue);
  }

  onIsOnboardedAsMulti() {
    const details = this.getPreferencesData();
    const newValue = !details.is_onboarded_as_multi;
    this.handleChange('is_onboarded_as_multi', newValue);
  }

  onStaffPreferenceHonoured() {
    const details = this.getPreferencesData();
    const newValue = !details.staff_preference_honoured;
    this.handleChange('staff_preference_honoured', newValue);
  }

  onExtraSecureAppointmentStrings() {
    const details = this.getPreferencesData();
    const newValue = !details.extra_secure_appointment_strings;
    this.handleChange('extra_secure_appointment_strings', newValue);
  }

  onSendStaffFirstName() {
    const details = this.getPreferencesData();
    const newValue = !details.send_staff_first_name;
    this.handleChange('send_staff_first_name', newValue);
  }

  onBlockBookingSwCalls() {
    const details = this.getPreferencesData();
    const newValue = !details.block_booking_sw_calls;
    this.handleChange('block_booking_sw_calls', newValue);
  }

  onBlockAutoProposal() {
    const details = this.getPreferencesData();
    const newValue = !details.block_auto_proposal;
    this.handleChange('block_auto_proposal', newValue);
  }

  onEnableSpeechHint() {
    const details = this.getPreferencesData();
    const newValue = !details.enable_speech_hint;
    this.handleChange('enable_speech_hint', newValue);
  }

  onEmailAddClient() {
    const details = this.getPreferencesData();
    const newValue = !details.email_add_client;
    this.handleChange('email_add_client', newValue);
  }

  onSmsAddClient() {
    const details = this.getPreferencesData();
    const newValue = !details.sms_add_client;
    this.handleChange('sms_add_client', newValue);
  }

  onCancelAndBook() {
    const details = this.getPreferencesData();
    const newValue = !details.cancel_and_book;
    this.handleChange('cancel_and_book', newValue);
  }

  onStaging() {
    const details = this.getPreferencesData();
    const newValue = !details.staging;
    this.handleChange('staging', newValue);
  }

  onCollectCcBeforeBooking() {
    const details = this.getPreferencesData();
    const newValue = details.collect_cc_before_booking;
    this.handleChange('collect_cc_before_booking', newValue);
  }

  onShowZeroDurationAppointmentSegments() {
    const details = this.getPreferencesData();
    const newValue = !details.show_zero_duration_appointment_segments;
    this.handleChange('show_zero_duration_appointment_segments', newValue);
  }

  onHideServiceTimes() {
    const details = this.getPreferencesData();
    const newValue = !details.hide_service_times;
    this.handleChange('hide_service_times', newValue);
  }

  onAllowUnpaidBookings() {
    const details = this.getPreferencesData();
    const newValue = !details.allow_unpaid_bookings;
    this.handleChange('allow_unpaid_bookings', newValue);
  }

  removeResourceStartTime(index) {
    const details = this.getPreferencesData();
    const currentArray = [...(details.resource_start_times || [])];
    currentArray.splice(index, 1);
    this.handleChange('resource_start_times', currentArray);
  }

  onResourceStartTimeChange(index, value) {
    const details = this.getPreferencesData();
    const currentArray = [...(details.resource_start_times || [])];
    currentArray[index] = value;
    this.handleChange('resource_start_times', currentArray);
  }

  onSubscribedEventChange(event, isChecked) {
    const details = this.getPreferencesData();
    const currentEvents = [
      ...(details.client_notification_preferences?.subscribed_events || []),
    ];

    if (isChecked) {
      if (!currentEvents.includes(event)) {
        currentEvents.push(event);
      }
    } else {
      const index = currentEvents.indexOf(event);
      if (index > -1) {
        currentEvents.splice(index, 1);
      }
    }

    this.handleChange('subscribed_events', currentEvents, true, 'client_notification_preferences');
  }

  onBlockedWordsInputChange(e) {
    this.setState({ blockedWordsInput: e.target.value });
  }

  addBlockedWord() {
    const word = this.state.blockedWordsInput.trim();
    if (word) {
      const details = this.getPreferencesData();
      const currentWords = [...(details.blocked_words_in_message || [])];
      if (!currentWords.includes(word)) {
        currentWords.push(word);
        this.handleChange('blocked_words_in_message', currentWords);
      }
      this.setState({ blockedWordsInput: '' });
    }
  }

  removeBlockedWord(index) {
    const details = this.getPreferencesData();
    const currentWords = [...(details.blocked_words_in_message || [])];
    currentWords.splice(index, 1);
    this.handleChange('blocked_words_in_message', currentWords);
  }

  static handleNameKeyPress(e) {
    const regex = /^[a-zA-Z\s]*$/;
    if (!regex.test(e.key)) {
      e.preventDefault();
    }
  }

  static getSelectedOption(options, value) {
    if (!value || !options || !Array.isArray(options)) {
      return null;
    }
    return options.find((option) => option.value === value) || null;
  }

  static safeStringifyJSON(obj) {
    try {
      if (typeof obj === 'string') {
        if (!obj || obj.trim() === '') {
          return '';
        }

        try {
          const parsed = JSON.parse(obj);
          return JSON.stringify(parsed, null, 2);
        } catch {
          return obj;
        }
      }

      if (obj === null || obj === undefined) {
        return '';
      }

      if (typeof obj === 'object') {
        return JSON.stringify(obj, null, 2);
      }

      return String(obj);
    } catch (error) {
      return '';
    }
  }

  render() {
    const { errors, onChange, setRef, disabled } = this.props;

    const details = this.getPreferencesData();
    const appointmentPrefs = details.appointment_preferences || {};
    const cancellationDetails = details.cancellation_details || {};
    const clientNotificationPrefs = details.client_notification_preferences || {};

    const businessId = this.props.business?.id || this.props.business?.info?.ID || this.props.business?.clientUser?.id || this.props.business?.details?.id;
    const isBusinessLoaded = businessId && this.props.business;
    const hasLocations = this.state.locationOptions.length > 1;

    const timeOptions = HiddenPreferences.generateTimeOptions();

    return (
      <div className="bookings scheduling hidden-preferences">
        {/* Blocked Fields Section */}
        <div className="bookings__section">
          <h4 style={{ marginBottom: '10px' }}>General preferences</h4>

          <div className="bookings__section">
            <div className="bookings__row">
              <p className="bookings__row__label">Message when request is forwarded</p>
              <div className="bookings__row__input">
                <span className="message--small message--error">
                  {this.getFieldError('request_forwarded_message') && this.getFieldError('request_forwarded_message').message}
                </span>
                <input
                  type="text"
                  placeholder="Enter forwarded message"
                  name="request_forwarded_message"
                  value={details.request_forwarded_message || ''}
                  onChange={this.onRequestForwardedMessageChange}
                  className={classnames({
                    'has-error': this.getFieldError('request_forwarded_message'),
                  })}
                  ref={setRef}
                  disabled={disabled}
                />
              </div>
            </div>
          </div>

          <div className="bookings__section">
            <div className="bookings__row">
              <p className="bookings__row__label">Blocked words that disable send button in TC</p>
              <div className="bookings__row__input">
                <span className="message--small message--error">
                  {this.getFieldError('blocked_words_in_message') && this.getFieldError('blocked_words_in_message').message}
                </span>
                <div style={{ display: 'flex', marginBottom: '10px' }}>
                  <input
                    type="text"
                    placeholder="Enter word to block"
                    value={this.state.blockedWordsInput}
                    onChange={this.onBlockedWordsInputChange}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        this.addBlockedWord();
                      }
                    }}
                    disabled={disabled}
                    style={{ flex: 1, marginRight: '10px' }}
                  />
                  <button
                    type="button"
                    onClick={this.addBlockedWord}
                    disabled={disabled}
                    className="btn btn-primary btn-sm"
                  >
                    Add
                  </button>
                </div>
                <div className="blocked-words-list">
                  {(details.blocked_words_in_message || []).map((word, index) => (
                    <span key={index} className="blocked-word-tag">
                      {word}
                      <button
                        type="button"
                        className="blocked-word-close"
                        onClick={() => this.removeBlockedWord(index)}
                        disabled={disabled}
                      >
                        ×
                      </button>
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Onboarded as multi-location?</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.is_onboarded_as_multi}
                name="is_onboarded_as_multi"
                onChange={this.onIsOnboardedAsMulti}
                disabled={disabled}
              />
            </div>
          </div>

          {details.is_onboarded_as_multi && hasLocations && (
            <div className="bookings__section">
              <div className="bookings__row" style={{ alignItems: 'flex-start' }}>
                <p className="bookings__row__label">Staff location preferences</p>
                <small>Please modify the fields within the JSON object. Clearing the entire object will reset it to its default values.</small>
                <div className="bookings__row__input">
                  <span className="message--small message--error">
                    {this.getFieldError('staff_location_preferences') && this.getFieldError('staff_location_preferences').message}
                  </span>
                  <TextareaCounter
                    rows="4"
                    name="staff_location_preferences"
                    value={HiddenPreferences.safeStringifyJSON(details.staff_location_preferences)}
                    onChange={this.onStaffLocationPreferencesChange}
                    className={classnames({
                      'has-error': this.getFieldError('staff_location_preferences'),
                    })}
                    ref={setRef}
                    maxLength={2000}
                    disabled={disabled}
                    placeholder={'{"staff_id": "12345", "preferred_locations": ["location1", "location2"], "workflow_type": "staff_location"}'}
                  />
                </div>
              </div>

              <div className="bookings__row" style={{ alignItems: 'flex-start' }}>
                <p className="bookings__row__label">Workflow preference for location</p>
                <small>Please modify the fields within the JSON object. Clearing the entire object will reset it to its default values.</small>
                <div className="bookings__row__input">
                  <span className="message--small message--error">
                    {this.getFieldError('location_workflow_preferences') && this.getFieldError('location_workflow_preferences').message}
                  </span>
                  <TextareaCounter
                    rows="4"
                    name="location_workflow_preferences"
                    value={HiddenPreferences.safeStringifyJSON(details.location_workflow_preferences)}
                    onChange={this.onLocationWorkflowPreferencesChange}
                    className={classnames({
                      'has-error': this.getFieldError('location_workflow_preferences'),
                    })}
                    ref={setRef}
                    maxLength={2000}
                    disabled={disabled}
                    placeholder={'{"primary_location": "location1", "fallback_locations": ["location2", "location3"], "workflow_type": "location_based"}'}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="bookings__row">
            <p className="bookings__row__label">Staff to avoid when booking</p>
            <div className="bookings__row__input">
              <Select
                value={HiddenPreferences.getSelectedBlockedOptions(this.state.staffOptions, details.blocked_staff)}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={this.state.staffOptions}
                styles={this.customStyles}
                onChange={this.onBlockedStaffChange}
                disabled={disabled}
                placeholder={this.state.staffOptions.length === 0 ? 'No staff available' : 'Select staff to block'}
                isClearable
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                isSearchable
                noOptionsMessage={() => 'No staff available'}
              />
            </div>
          </div>

          <div className="bookings__row">
            <p className="bookings__row__label">Services to block from booking</p>
            <div className="bookings__row__input">
              <Select
                value={HiddenPreferences.getSelectedBlockedOptions(this.state.serviceOptions, details.blocked_service)}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={this.state.serviceOptions}
                styles={this.customStyles}
                onChange={this.onBlockedServiceChange}
                disabled={disabled}
                placeholder={this.state.serviceOptions.length === 0 ? 'No services available' : 'Select services to block'}
                isClearable
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                isSearchable
                noOptionsMessage={() => 'No services available'}
              />
            </div>
          </div>

          <div className="bookings__row">
            <p className="bookings__row__label">Blocked business locations</p>
            <div className="bookings__row__input">
              <Select
                value={HiddenPreferences.getSelectedBlockedOptions(this.state.locationOptions.filter((loc) => loc.value !== ''), details.blocked_location)}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={this.state.locationOptions.filter((loc) => loc.value !== '')}
                styles={this.customStyles}
                onChange={this.onBlockedLocationChange}
                disabled={disabled}
                placeholder={!hasLocations ? 'No locations available' : 'Select locations to block'}
                isClearable
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                isSearchable
                noOptionsMessage={() => 'No locations available'}
              />
            </div>
          </div>

          <div className="bookings__row">
            <p className="bookings__row__label">Resources to exclude</p>
            <div className="bookings__row__input">
              <Select
                value={HiddenPreferences.getSelectedBlockedOptions(this.state.resourceOptions, details.blocked_resources)}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={this.state.resourceOptions}
                styles={this.customStyles}
                onChange={this.onBlockedResourceChange}
                disabled={disabled}
                placeholder={this.state.resourceOptions.length === 0 ? 'No resources available' : 'Select resources to block'}
                isClearable
                isMulti
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                isSearchable
                noOptionsMessage={() => 'No resources available'}
              />
            </div>
          </div>
        </div>

        <div className="bookings__section">
          {(details.resource_start_times || []).map((time, index) => (
            <div key={index} className="bookings__row array-item">
              <p className="bookings__row__label">START TIME {index + 1}</p>
              <div className="bookings__row__input array-input">
                <input
                  type="time"
                  value={time}
                  onChange={(e) => this.onResourceStartTimeChange(index, e.target.value)}
                  disabled={disabled}
                />
                <button
                  type="button"
                  onClick={() => this.removeResourceStartTime(index)}
                  disabled={disabled}
                  className="btn btn-danger btn-sm"
                >
                  Remove
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="bookings__section">
          <div className="bookings__row" style={{ alignItems: 'flex-start' }}>
            <p className="bookings__row__label">Are there any specific post-booking messages you would like TL to share?</p>
            <small>Please modify the fields within the JSON object. Clearing the entire object will reset it to its default values.</small>
            <div className="bookings__row__input">
              <span className="message--small message--error">
                {errors.custom_post_booking_instructions
                  && errors.custom_post_booking_instructions.message}
              </span>
              <TextareaCounter
                rows="4"
                name="custom_post_booking_instructions"
                value={HiddenPreferences.safeStringifyJSON(details.custom_post_booking_instructions)}
                onChange={this.onCustomPostBookingInstructionsChange}
                className={classnames({
                  'has-error': errors.custom_post_booking_instructions,
                })}
                ref={setRef}
                maxLength={1000}
                disabled={disabled}
                placeholder={'{"BUSINESS": [{"type_id": "504318", "instructions": "Your instructions here"}]}'}
              />
            </div>
          </div>
        </div>

        <div className="bookings__section">
          <div className="bookings__row">
            <p className="bookings__row__label">Internal notes</p>
            <div className="bookings__row__input">
              <span className="message--small message--error">
                {this.getFieldError('notes') && this.getFieldError('notes').message}
              </span>
              <TextareaCounter
                rows="3"
                name="notes"
                value={details.notes || ''}
                onChange={this.onNotesChange}
                className={classnames({
                  'has-error': this.getFieldError('notes'),
                })}
                ref={setRef}
                maxLength={500}
                disabled={disabled}
                placeholder="Enter notes"
              />
            </div>
          </div>
        </div>

        <div className="bookings__section">
          <div className="bookings__row">
            <p className="bookings__row__label">
              <span className="title">Preferred default location</span>
            </p>
            <div className="bookings__row__input">
              <Select
                value={this.getSelectedLocationOption()}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={this.state.locationOptions}
                styles={this.customStyles}
                onChange={this.onPreferredLocationChange}
                disabled={disabled || !hasLocations}
                placeholder={
                  !isBusinessLoaded
                    ? 'Loading locations...'
                    : !hasLocations
                      ? 'No locations available'
                      : 'Select preferred location'
                }
                isClearable
                noOptionsMessage={() => 'No locations available'}
                isSearchable
                menuPlacement="auto"
                maxMenuHeight={200}
              />
            </div>
          </div>
        </div>

        <div className="bookings__section">
          <div className="bookings__row">
            <p className="bookings__row__label">
              <span className="title">Minimum slot size</span>
            </p>
            <div className="bookings__row__input">
              <span className="message--small message--error">
                {errors.slot_size && errors.slot_size.message}
              </span>
              <Select
                value={HiddenPreferences.getSelectedOption(
                  this.slotSizeOptions,
                  details.slot_size || 'PT5M',
                )}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={this.slotSizeOptions}
                styles={this.customStyles}
                onChange={this.onSlotSizeChange}
                disabled={disabled}
                placeholder="Select slot size"
                isClearable
              />
            </div>
          </div>
        </div>

        <div className="bookings__section">
          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Gap between appointment slots (5-60 minutes)</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!(details.slot_interval && details.slot_interval !== null && details.slot_interval !== false)}
                name="slot_interval_enable"
                onChange={this.onSlotIntervalToggle}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row__input">
            <input
              type="range"
              min="5"
              max="60"
              step="5"
              value={(() => {
                const slotInterval = details.slot_interval;
                if (!slotInterval || slotInterval === null) {
                  return 15;
                }
                if (typeof slotInterval === 'string' && slotInterval.startsWith('PT') && slotInterval.endsWith('M')) {
                  const minutes = parseInt(slotInterval.slice(2, -1), 10);
                  return Number.isNaN(minutes) ? 15 : minutes;
                }
                return typeof slotInterval === 'number' ? slotInterval : 15;
              })()}
              onChange={this.onSlotIntervalChange}
              disabled={disabled || !(details.slot_interval && details.slot_interval !== null && details.slot_interval !== false)}
              style={{
                width: '100%',
                marginBottom: '5px',
                WebkitAppearance: 'none',
                appearance: 'none',
                height: '8px',
                borderRadius: '4px',
                outline: 'none',
                opacity: (details.slot_interval && details.slot_interval !== null && details.slot_interval !== false) ? 1 : 0.5,
                background: `linear-gradient(to right, #207cc2 0%, #207cc2 ${(() => {
                  const slotInterval = details.slot_interval;
                  let minutes = 15;
                  if (slotInterval && slotInterval !== null) {
                    if (typeof slotInterval === 'string' && slotInterval.startsWith('PT') && slotInterval.endsWith('M')) {
                      minutes = parseInt(slotInterval.slice(2, -1), 10);
                    } else if (typeof slotInterval === 'number') {
                      minutes = slotInterval;
                    }
                  }
                  return ((minutes - 5) / (60 - 5)) * 100;
                })()}%, #e0e0e0 
                  ${(() => {
                  const slotInterval = details.slot_interval;
                  let minutes = 15;
                  if (slotInterval && slotInterval !== null) {
                    if (typeof slotInterval === 'string' && slotInterval.startsWith('PT') && slotInterval.endsWith('M')) {
                      minutes = parseInt(slotInterval.slice(2, -1), 10);
                    } else if (typeof slotInterval === 'number') {
                      minutes = slotInterval;
                    }
                  }

                  return ((minutes - 5) / (60 - 5)) * 100;
                })()}%, #e0e0e0 100%)`,
              }}
            />
            <style>
              {`
              input[type="range"]::-webkit-slider-thumb {
                -webkit-appearance: none;
                appearance: none;
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background: #207cc2;
                cursor: pointer;
                border: 2px solid #ffffff;
                box-shadow: 0 2px 4px rgba(0,0,0,0.2);
              }
              
              input[type="range"]::-moz-range-thumb {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background: #207cc2;
                cursor: pointer;
                border: 2px solid #ffffff;
                box-shadow: 0 2px 4px rgba(0,0,0,0.2);
              }
              
              input[type="range"]::-ms-thumb {
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background: #207cc2;
                cursor: pointer;
                border: 2px solid #ffffff;
                box-shadow: 0 2px 4px rgba(0,0,0,0.2);
              }
              
              input[type="range"]:disabled::-webkit-slider-thumb {
                background: #ccc;
                cursor: not-allowed;
              }
              
              input[type="range"]:disabled::-moz-range-thumb {
                background: #ccc;
                cursor: not-allowed;
              }
              
              input[type="range"]:disabled::-ms-thumb {
                background: #ccc;
                cursor: not-allowed;
              }
              `}
            </style>
            <div style={{ textAlign: 'center', fontSize: '14px', color: (details.slot_interval && details.slot_interval !== null && details.slot_interval !== false) ? '#666' : '#ccc' }}>
              {(() => {
                const slotInterval = details.slot_interval;
                if (!slotInterval || slotInterval === null) {
                  return '';
                }

                let minutes;
                if (typeof slotInterval === 'string' && slotInterval.startsWith('PT') && slotInterval.endsWith('M')) {
                  minutes = parseInt(slotInterval.slice(2, -1), 10);
                } else if (typeof slotInterval === 'number') {
                  minutes = slotInterval;
                } else {
                  return '';
                }

                return `${minutes} minutes`;
              })()}
            </div>
          </div>
        </div>

        <div className="bookings__section">
          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Auto-cancel if user inactive</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.can_auto_cancel_if_user_inactive}
                name="can_auto_cancel_if_user_inactive"
                onChange={this.onAutoCancel}
                disabled={disabled}
              />
            </div>
          </div>
        </div>

        <div className="bookings__section">
          <div className="bookings__row">
            <p className="bookings__row__label">Login link for the business user</p>
            <div className="bookings__row__input">
              <span className="message--small message--error">
                {this.getFieldError('user_login_link') && this.getFieldError('user_login_link').message}
              </span>
              <input
                type="text"
                placeholder="www.example.com or https://www.example.com"
                name="user_login_link"
                value={details.user_login_link || ''}
                onChange={this.onUserLoginLinkChange}
                className={classnames({
                  'has-error': this.getFieldError('user_login_link'),
                })}
                ref={setRef}
                disabled={disabled}
              />
            </div>
          </div>
        </div>

        <div className="bookings__section">
          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Indicates if business has multiple locations</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.is_multi_location}
                name="is_multi_location"
                onChange={this.onIsMultiLocation}
                disabled={disabled}
              />
            </div>
          </div>
        </div>

        <div className="bookings__section">
          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Honor staff preferences?</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.staff_preference_honoured}
                name="staff_preference_honoured"
                onChange={this.onStaffPreferenceHonoured}
                disabled={disabled}
              />
            </div>
          </div>

          {/* Security Settings */}
          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Enable stricter appointment info privacy?</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.extra_secure_appointment_strings}
                name="extra_secure_appointment_strings"
                onChange={this.onExtraSecureAppointmentStrings}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Send staff&apos;s first name only in replies?</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.send_staff_first_name}
                name="send_staff_first_name"
                onChange={this.onSendStaffFirstName}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Disable all downstream booking software calls</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.block_booking_sw_calls}
                name="block_booking_sw_calls"
                onChange={this.onBlockBookingSwCalls}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Block automatic appointment suggestions</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.block_auto_proposal}
                name="block_auto_proposal"
                onChange={this.onBlockAutoProposal}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Send staff info in replies?</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.send_staff_info}
                name="send_staff_info"
                onChange={this.onSendStaffInfo}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Enable hint for speech capture</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.enable_speech_hint}
                name="enable_speech_hint"
                onChange={this.onEnableSpeechHint}
                disabled={disabled}
              />
            </div>
          </div>

          {/* Client Communication Settings */}
          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Send email when adding client</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.email_add_client}
                name="email_add_client"
                onChange={this.onEmailAddClient}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Send SMS when adding client</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.sms_add_client}
                name="sms_add_client"
                onChange={this.onSmsAddClient}
                disabled={disabled}
              />
            </div>
          </div>
        </div>

        <div className="bookings__section">
          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Promotional Add Client</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.promotional_add_client}
                name="promotional_add_client"
                onChange={this.onPromotionalAddClient}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Send notification on all bookings</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!clientNotificationPrefs.always_notify}
                name="always_notify"
                onChange={this.onAlwaysNotify}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row">
            <p className="bookings__row__label">Time to follow up for Lead Engage</p>
            <div className="bookings__row__input">
              <Select
                value={HiddenPreferences.getSelectedOption(
                  timeOptions,
                  details.lead_engage_follow_up_time,
                )}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={timeOptions}
                styles={this.customStyles}
                onChange={this.onLeadEngageFollowUpTimeChange}
                disabled={disabled}
                placeholder="Select follow up time"
                isClearable
              />
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Send booking notification status from LeadEngage</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.send_le_status_bn}
                name="send_le_status_bn"
                onChange={this.onSendLeStatusBn}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Cancel before re-booking flow</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.cancel_and_book}
                name="cancel_and_book"
                onChange={this.onCancelAndBook}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Business is in staging/test mode</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.staging}
                name="staging"
                onChange={this.onStaging}
                disabled={disabled}
              />
            </div>
          </div>
        </div>

        <h4 style={{ marginBottom: '10px' }}>Appointment Preferences</h4>

        <div className="bookings__section">
          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Collect CC Before Booking (Read only)</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={details.collect_cc_before_booking}
                name="collect_cc_before_booking"
                onChange={this.onCollectCcBeforeBooking}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row">
            <p className="bookings__row__label">
              <span className="title">CC Wait Time To Booking</span>
            </p>
            <div className="bookings__row__input">
              <Select
                value={HiddenPreferences.getSelectedOption(
                  this.durationOptions,
                  details.cc_wait_time_to_booking,
                )}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={this.durationOptions}
                styles={this.customStyles}
                onChange={this.onCcWaitTimeToBookingChange}
                disabled={disabled}
                placeholder="Select wait time"
                isClearable
              />
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Accept Voucher Bookings</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!appointmentPrefs.accept_voucher_bookings}
                name="accept_voucher_bookings"
                onChange={this.onAcceptVoucherBookings}
                disabled={disabled}
              />
            </div>
          </div>
        </div>

        <div className="bookings__section">
          <div className="bookings__row">
            <p className="bookings__row__label">
              <span className="title">Availability Type</span>
            </p>
            <div className="bookings__row__input">
              <Select
                value={HiddenPreferences.getSelectedOption(
                  this.availabilityOptions,
                  appointmentPrefs.availability_type,
                )}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={this.availabilityOptions}
                styles={this.customStyles}
                onChange={this.onAvailabilityTypeChange}
                disabled={disabled}
                placeholder="Select availability type"
                isClearable
              />
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Show Zero Duration Appointment Segments</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.show_zero_duration_appointment_segments}
                name="show_zero_duration_appointment_segments"
                onChange={this.onShowZeroDurationAppointmentSegments}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Hide Service Times</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.hide_service_times}
                name="hide_service_times"
                onChange={this.onHideServiceTimes}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row">
            <p className="bookings__row__label">
              <span className="title">Staff Schedule Span</span>
            </p>
            <div className="bookings__row__input">
              <Select
                value={HiddenPreferences.getSelectedOption(
                  this.durationOptions,
                  details.staff_schedule_span,
                )}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={this.durationOptions}
                styles={this.customStyles}
                onChange={this.onStaffScheduleSpanChange}
                disabled={disabled}
                placeholder="Select schedule span"
                isClearable
              />
            </div>
          </div>
        </div>

        <div className="bookings__section">
          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Reschedule Any Staff</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!appointmentPrefs.reschedule_any_staff}
                name="reschedule_any_staff"
                onChange={this.onRescheduleAnyStaff}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Linked Appointment With Same Staff</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!appointmentPrefs.linked_appointment_with_same_staff}
                name="linked_appointment_with_same_staff"
                onChange={this.onLinkedAppointmentWithSameStaff}
                disabled={disabled}
              />
            </div>
          </div>

          <div className="bookings__row special-row">
            <p className="bookings__row__label">
              <span className="title">Allow Unpaid Bookings</span>
            </p>
            <div className="bookings__row__input">
              <ToggleSwitch
                checked={!!details.allow_unpaid_bookings}
                name="allow_unpaid_bookings"
                onChange={this.onAllowUnpaidBookings}
                disabled={disabled}
              />
            </div>
          </div>
        </div>

        {/* <div className="bookings__section">
          <div className="bookings__row">
            <p className="bookings__row__label">Custom greeting file name</p>
            <div className="bookings__row__input">
              <span className="message--small message--error">
                {this.getFieldError('customGreetingFName') && this.getFieldError('customGreetingFName').message}
              </span>
              <input
                type="text"
                placeholder="e.g., custom-greeting.mp3"
                name="customGreetingFName"
                value={details.customGreetingFName || ''}
                onChange={this.onCustomGreetingFNameChange}
                className={classnames({
                  'has-error': this.getFieldError('customGreetingFName'),
                })}
                ref={setRef}
                disabled={disabled}
              />
            </div>
          </div>
        </div> */}

        {/* <div className="bookings__section">
          <div className="bookings__row">
            <p className="bookings__row__label">
              <span className="title">Pre Workflow Type</span>
            </p>
            <div className="bookings__row__input">
              <Select
                value={HiddenPreferences.getSelectedOption(
                  this.workflowOptions,
                  details.pre_workflow_type,
                )}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={this.workflowOptions}
                styles={this.customStyles}
                onChange={this.onWorkflowTypeChange}
                disabled={disabled}
                placeholder="Select workflow type"
                isClearable
              />
            </div>
          </div>
        </div> */}

        <div className="bookings__section">
          {/* <div className="bookings__row">
            <p className="bookings__row__label">
              <span className="title">Notification Frequency</span>
            </p>
            <div className="bookings__row__input">
              <Select
                value={HiddenPreferences.getSelectedOption(
                  this.notificationOptions,
                  clientNotificationPrefs.notification_frequency,
                )}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={this.notificationOptions}
                styles={this.customStyles}
                onChange={this.onNotificationFrequencyChange}
                disabled={disabled}
                placeholder="Select frequency"
                isClearable
              />
            </div>
          </div> */}

          <div className="bookings__row">
            <p className="bookings__row__label">
              <span className="title">Notify Business Brand</span>
            </p>
            <div className="bookings__row__input">
              <Select
                value={HiddenPreferences.getSelectedOption(
                  this.businessBrandOptions,
                  clientNotificationPrefs.notifyBusinessBrand,
                )}
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.value}
                options={this.businessBrandOptions}
                styles={this.customStyles}
                onChange={this.onBusinessBrandChange}
                disabled={disabled}
                placeholder="Select option"
                isClearable
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

HiddenPreferences.defaultProps = {
  onChange: () => {},
  setRef: () => {},
  details: {},
  errors: {},
  disabled: false,
  business: {},
  apiData: {},
  preferences: {},
};

HiddenPreferences.propTypes = {
  onChange: PropTypes.func,
  setRef: PropTypes.func,
  details: PropTypes.shape(),
  errors: PropTypes.shape(),
  disabled: PropTypes.bool,
  setDropDownLocation: PropTypes.func,
  onErrorChange: PropTypes.func,
  apiData: PropTypes.shape(),
  preferences: PropTypes.shape(),
  business: PropTypes.shape({
    info: PropTypes.object,
    selectedLocation: PropTypes.object,
    businessDetailsFetched: PropTypes.bool,
    locations: PropTypes.arrayOf(PropTypes.shape({
      studioId: PropTypes.string,
      studioName: PropTypes.string,
      locationName: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      disabled: PropTypes.bool,
    })),
    details: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      locations: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        display_text: PropTypes.string,
        city: PropTypes.string,
        state: PropTypes.string,
        disabled: PropTypes.bool,
      })),
      staffs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
      })),
      services: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        display_name: PropTypes.string,
      })),
      resources: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        display_name: PropTypes.string,
      })),
    }),
    data: PropTypes.shape({
      staffs: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        first_name: PropTypes.string,
        last_name: PropTypes.string,
      })),
      services: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        display_name: PropTypes.string,
      })),
      resources: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string,
        display_name: PropTypes.string,
      })),
    }),
    staffs: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      first_name: PropTypes.string,
      last_name: PropTypes.string,
      staff_type: PropTypes.string,
    })),
    services: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      display_name: PropTypes.string,
      business_id: PropTypes.string,
      capacity: PropTypes.number,
      staff_required: PropTypes.number,
      cost: PropTypes.number,
    })),
    resources: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      display_name: PropTypes.string,
      business_id: PropTypes.string,
    })),
  }),
};
